<script>
import { required } from "vuelidate/lib/validators";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import DatePicker from "vue2-datepicker";
import {cloneDeep} from 'lodash';
export default {
    name: 'BillingCreation',
    components: {
        MaskedInput,
        DatePicker
    },
    data(){
        return {
            pageNo: 1,
            clientOpt: 'walk-in',
            billing: {
                id: null,
                billingDate: null,
                description: null,
                reference: null,
                clientId: null,
                clientName: null,
                clientAddress: null,
                clientTin: null,
                clientZip: null,
                deliveryUnitServiceId: null,
                dueDate: null,
                penaltyPerDay: null,
                emailSms: false,
                billingDetails: null,
                clientType: null
            },
            submitted: false,
            searchDone: false,
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            duService: null,
            selectedTemplate: { id: 0 },
            loadFees: false
        }
    },
    validations: {
        billing: {
            billingDate: { required },
            description: { required },
            clientName: { required },
            clientType: { required },
            dueDate: { required },
        },
    },
    methods: {
        updateBilling(data){
            data.duService.templates = [];
            this.pageNo = 3;
            this.clientOpt = data.clientType;
            this.searchDone = true;
            this.duService = cloneDeep(data.duService);
            this.billing = cloneDeep(data);
            this.billing.billingDate = new Date(data.billingDate);
            this.billing.dueDate = new Date(data.dueDate);
            this.billing.penaltyPerDay = data.penaltyPerDay ? data.penaltyPerDay.toString() : '';
            this.billing.billingDetails.map(item => {
                item.name = item.fee;
                item.amount = item.amount.toString()
                item.quantity = item.quantity.toString(),
                item.total = parseFloat(item.amount) * parseFloat(item.quantity)
            })
            this.selectedTemplate = data.duService.templates.length ? data.duService.templates[0] : { id: 0 };
            this.selectedTemplate.deliveryUnitServiceFees = data.billingDetails.map(item => {
                return {
                    feeId: item.feeId,
                    feeName: item.name,
                    account: item.account,
                    amount: item.amount
                }
            })
        },
        resetBilling(){
            this.pageNo = 1;
            this.clientOpt = 'walk-in';
            this.searchDone = false;
            this.duService = null;
            this.billing = {
                id: 0,
                billingDate: new Date(),
                description: null,
                reference: null,
                clientId: null,
                clientName: null,
                clientAddress: null,
                clientTin: null,
                clientZip: null,
                deliveryUnitServiceId: null,
                dueDate: new Date(),
                penaltyPerDay: null,
                clientType: null,
                emailSms: false,
                billingDetails: []
            }
        },
        nextMove(no){
            if(no == 1){
                return this.clientOpt != '' && this.billing.clientName && this.billing.clientName != '';
            }
            if(no == 2){
                return this.billing.deliveryUnitServiceId && 
                this.billing.dueDate && 
                this.billing.billingDetails.length && 
                this.getTotals('total') > 0;
            }  
            return false;
        },
        nextNow(){
            this.pageNo++;
        },
        searchClient(type){
            if(type == 'client'){
                this.$emit('search-client')
            }else{
                this.$emit('search-employee')
            }
        },
        setBiller(client){
            this.searchDone = true;
            this.billing.clientId = client.clientId;
            this.billing.clientName = client.clientName;
            this.billing.clientAddress = client.clientAddress;
            this.billing.clientTin = client.clientTin;
            this.billing.clientZip = client.clientZip;
        },
        changeOpt(type){
            this.searchDone = false;
            this.clientOpt = type;
            this.billing.clientId = null;
            this.billing.clientName = null;
            this.billing.clientAddress = null;
            this.billing.clientTin = null;
            this.billing.clientZip = null;
        },
        addFees(){
            this.$emit('add-fee', this.billing.billingDetails ? this.billing.billingDetails : [])
        },
        addFeesToBilling(fees){
            fees.map(item => {
                this.billing.billingDetails.push({
                    feeId: item.id,
                    name: item.name,
                    account: item.account.accountName,
                    quantity: '1',
                    amount: item.defaultAmount.toString(),
                    total: item.defaultAmount
                })
                this.selectedTemplate.deliveryUnitServiceFees.push({
                    feeId: item.id,
                    feeName: item.name,
                    account: item.account.accountName,
                    amount: item.defaultAmount
                })
            })
            
        },
        async removeFee(fee, ind){
            if(fee.id > 0){
                await this.$store
                    .dispatch("billing/deleteBillingDetail", fee.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.billing.billingDetails.splice(ind, 1);
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong", "error");
                    })
            }else{
                this.billing.billingDetails.splice(ind, 1);
            }
            
        },
        createBill(){
            this.billing.clientType = this.clientOpt;
            this.billing.duService = this.duService;
            this.$emit('create-bill', this.billing)
        },
        searchDUServices(){
            this.$emit('search-du-services')
        },
        clearDUService(){
            this.duService = null;
            this.billing.deliveryUnitServiceId = null;
        },
        async setDUService(data){
            this.duService = data;
            this.billing.deliveryUnitServiceId = data.id;
            this.loadFees = true;
            await this.getServiceTemplates(data);
            this.loadFees = false;
        },
        async getServiceTemplates(item){
            await this.$store
                .dispatch("duservicefeetemplate/getDUServiceFeeTemplatesByService", item.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    item.templates = res.data;
                    if(res.data.length){
                        console.log(res.data[0]);
                        this.selectedTemplate = res.data[0];
                        this.billing.billingDetails = res.data[0].deliveryUnitServiceFees.map(item => {
                            return {
                                feeId: item.feeId,
                                name: item.feeName,
                                account: item.account,
                                quantity: '1',
                                amount: item.amount.toString(),
                                total: item.amount,
                            }
                        })
                    }
                })
                .catch((err) => {
                    this.showToast("Something went wrong! Cannot fetch delivery unit service templates.", "error");
                });
        },
        
        getTotals(type){
            if(!this.billing.billingDetails) return 0;
            if(type == 'qty'){
                return this.billing.billingDetails.reduce((a, b) => {
                    return a + parseFloat(b.quantity);
                }, 0);
            }
            if(type == 'amount'){
                return this.billing.billingDetails.reduce((a, b) => {
                    return a + parseFloat(this.getExactAmt(b.amount));
                }, 0);
            }
            if(type == 'total'){
                return this.billing.billingDetails.reduce((a, b) => {
                    return a + parseFloat(this.getExactAmt(parseFloat(b.quantity) * parseFloat(b.amount)));
                }, 0);
            }
            return 0;
        },
        selectTemplate(item){
            this.selectedTemplate = item;
            this.billing.billingDetails = item.deliveryUnitServiceFees.map(item => {
                return {
                    feeId: item.feeId,
                    name: item.feeName,
                    account: item.account,
                    quantity: '1',
                    amount: item.amount.toString(),
                    total: item.amount,
                }
            })
        }
    }
}
</script>

<template>
    <b-modal
        id="create-billing"
        title="Create Billing"
        size="xl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <template v-if="pageNo == 1">
            <div class="row">
                <div class="col-md-6">
                    <small>Select Type</small>
                    <div class="d-flex gap-2 flex-column mt-1 mb-2 justify-space-around">
                        <div class="option-pane" :class="{active: clientOpt == 'walk-in'}" @click="changeOpt('walk-in')">
                            <div class="img-pane">
                                <img src="@/assets/images/other-pics/walk.png" alt="walk-in" class="img-fluid">
                            </div>
                            <p class="mb-0">Walk In</p>
                        </div>
                        <div class="option-pane" :class="{active: clientOpt == 'client'}" @click="changeOpt('client')">
                            <div class="img-pane">
                                <img src="@/assets/images/other-pics/client.png" alt="walk-in" class="img-fluid">
                            </div>
                            <p class="mb-0">Client</p>
                        </div>
                        <div class="option-pane" :class="{active: clientOpt == 'employee'}" @click="changeOpt('employee')">
                            <div class="img-pane">
                                <img src="@/assets/images/other-pics/employee.png" alt="walk-in" class="img-fluid">
                            </div>
                            <p class="mb-0">Employee</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div v-if="clientOpt == 'walk-in'">
                        <small>**Options for Walk In</small>
                        <div class="px-2 mt-2">
                            <b-form-group label="Client Name" class="mb-3" label-class="text-info font-weight-bold">
                                <b-form-input
                                    v-model="billing.clientName"
                                    placeholder="Enter client name"
                                    :class="{ 'is-invalid': $v.billing.clientName.$error }"
                                ></b-form-input>
                                <div v-if="$v.billing.clientName.$error" class="invalid-feedback">
                                    <span v-if="!$v.billing.clientName.required">Client name is required.</span>
                                </div>
                            </b-form-group>
                            <b-form-group label="Client Address" class="mb-3" label-class="text-info font-weight-bold">
                                <b-form-input
                                    v-model="billing.clientAddress"
                                    placeholder="Enter client address"
                                ></b-form-input>
                            </b-form-group>
                            <b-form-group label="Client ZIP" class="mb-3" label-class="text-info font-weight-bold">
                                <b-form-input
                                v-model="billing.clientZip"
                                placeholder="Enter client ZIP"
                                ></b-form-input>
                            </b-form-group>
                            <b-form-group label="Client TIN" class="mb-3" label-class="text-info font-weight-bold">
                                <b-form-input
                                v-model="billing.clientTin"
                                placeholder="Enter client TIN"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                    </div>
                    <div v-if="clientOpt && clientOpt != 'walk-in'">
                        <small class="line-height-1">**You can type to search and hit enter or you can just click the search button.</small>
                        <label class="mb-0 mt-2 text-info font-weight-bold">Select {{clientOpt}} from list</label>
                        <b-input-group class="mt-2 mb-3">
                            <template #append>
                                <b-button 
                                    @click="searchClient(clientOpt)"
                                    variant="outline-info"
                                >
                                    <i class="mdi mdi-clipboard-text-search-outline"></i>
                                </b-button>
                            </template>
                            <input
                                autocomplete="off"
                                type="text"
                                :placeholder="`Search ${clientOpt}...`"
                                class="form-control"
                                v-model="billing.clientName"
                                disabled
                            />
                        </b-input-group>
                        <template v-if="searchDone">
                            <b-form-group label="Client Address" class="mb-3" label-class="text-info font-weight-bold">
                                <b-form-input
                                    v-model="billing.clientAddress"
                                    placeholder="Enter client address"
                                ></b-form-input>
                            </b-form-group>
                            <b-form-group label="Client ZIP" class="mb-3" label-class="text-info font-weight-bold">
                                <b-form-input
                                    v-model="billing.clientZip"
                                    placeholder="Enter client ZIP"
                                ></b-form-input>
                            </b-form-group>
                            <b-form-group label="Client TIN" class="mb-3" label-class="text-info font-weight-bold">
                                <b-form-input
                                    v-model="billing.clientTin"
                                    placeholder="Enter client TIN"
                                ></b-form-input>
                            </b-form-group>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="pageNo == 2">
            <!-- <b-form-group label="Reference Number" class="mb-3" label-class="text-info font-weight-bold">
                <b-form-input
                    v-model="billing.reference"
                    placeholder="Enter Reference Number"
                ></b-form-input>
            </b-form-group> -->
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-2">
                        <label class="mb-0 text-info font-weight-bold">Delivery Unit Service</label>
                        <div class="d-flex">
                            <div class="form-control w-100" style="min-height:40px;">
                                <p class="mb-0" style="color:rgba(255, 255, 255, 0.2);" v-if="!duService">Search Delivery Unit Services...</p>
                                <template v-else>
                                    <p class="font-weight-bold mb-0 text-yellow">
                                        {{duService.name}}
                                    </p>
                                    <p class="font-weight-bold mb-0 ps-3">
                                        {{duService.serviceName}}
                                    </p>
                                </template>
                            </div>
                            <b-button 
                                v-if="duService"
                                @click="clearDUService"
                                variant="outline-danger"
                            >
                                <i class="bx bx-x"></i>
                            </b-button>
                            <b-button 
                                @click="searchDUServices"
                                variant="outline-info"
                            >
                                <i class="mdi mdi-clipboard-text-search-outline"></i>
                            </b-button>
                        </div>
                    </div>
                    <b-form-group label="Billing Date" class="mb-2" label-class="text-info font-weight-bold">
                        <date-picker
                            id="billingDate"
                            v-model="billing.billingDate"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Billing Date..."
                            :class="{ 'is-invalid': $v.billing.billingDate.$error }"
                        >
                        </date-picker>
                        <div v-if="$v.billing.billingDate.$error" class="invalid-feedback">
                        <span v-if="!$v.billing.billingDate.required"
                            >Billing date is required.</span
                        >
                        </div>
                    </b-form-group>
                    <b-form-group label="Due Date" class="mb-2" label-class="text-info font-weight-bold">
                        <date-picker
                            id="billingDate"
                            v-model="billing.dueDate"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Billing Date..."
                            :class="{ 'is-invalid': $v.billing.dueDate.$error }"
                        >
                        </date-picker>
                        <div v-if="$v.billing.dueDate.$error" class="invalid-feedback">
                        <span v-if="!$v.billing.dueDate.required">Billing date is required.</span>
                        </div>
                    </b-form-group>
                    <b-form-group label="Description" class="mb-2" label-class="text-info font-weight-bold">
                        <b-form-textarea
                            v-model="billing.description"
                            rows="4"
                            :class="{ 'is-invalid': $v.billing.description.$error }"
                        ></b-form-textarea>
                        <div v-if="$v.billing.description.$error" class="invalid-feedback">
                        <span v-if="!$v.billing.description.required"
                            >Description is required.</span
                        >
                        </div>
                    </b-form-group>
                    <b-form-group label="Penalty per Day (%)" class="mb-3" label-class="text-info font-weight-bold">
                        <masked-input
                        autocomplete="off"
                        type="text"
                        v-model="billing.penaltyPerDay"
                        placeholder="Enter Percentage..."
                        class="form-control"
                        :mask="currencyMask"
                        >
                        </masked-input>
                    </b-form-group>
                    <b-form-group>
                        <div class="form-check form-checkbox-outline form-check-success my-2">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="emailSms"
                            v-model="billing.emailSms"
                        />
                        <label class="form-check-label" for="emailSms">
                            Tick check if you want to send notification
                        </label>
                        </div>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <h5 class="card-title text-info font-weight-bold mb-0">List of Fees</h5>
                        <button
                            class="btn btn-info btn-sm"
                            @click="addFees"
                            v-if="duService"
                        >
                            <i class="bx bx-plus"></i> Add {{ billing.billingDetails && billing.billingDetails.length ? 'More' : '' }} Fees
                        </button>
                    </div>
                    <div class="mb-2" v-if="duService && duService.templates.length">
                        <p class="mb-2 font-size-16 font-weight-bold">Select Template:</p>
                        <div class="d-flex">
                            <template v-for="x in duService.templates">
                                <div :key="x.id" class="template-opts px-4 cursor-pointer" :class="{active: x.id == selectedTemplate.id}" @click="selectTemplate(x)">{{x.templateName}}</div>
                            </template>
                        </div>
                    </div>
                    <table class="table table-sm table-hover table-bordered">
                        <thead>
                            <tr>
                                <th>Fee</th>
                                <th style="width:80px">Qty</th>
                                <th style="width:120px">Amount</th>
                                <th style="width:120px">Total</th>
                                <th style="width:30px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="!billing.billingDetails.length">
                                <tr>
                                    <td colspan="100%" class="text-center">No data found.</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr v-if="loadFees">
                                    <td colspan="100%" class="text-center">Loading...</td>
                                </tr>
                                <template v-if="!loadFees && !billing.billingDetails.length">
                                    <tr>
                                        <td colspan="100%" class="text-center">No data found.</td>
                                    </tr>
                                </template>
                                <template v-if="!loadFees && billing.billingDetails.length">
                                    <tr v-for="(fee, index) in billing.billingDetails" :key="index">
                                        <td>
                                            <p class="mb-0">{{ fee.name }}</p>
                                            <small>{{fee.account}}</small>
                                        </td>
                                        <td>
                                            <masked-input
                                                autocomplete="off"
                                                type="text"
                                                v-model="fee.quantity"
                                                placeholder="Enter Qty..."
                                                class="form-control text-right"
                                                :mask="currencyMask"
                                            >
                                            </masked-input>
                                        </td>
                                        <td>
                                            <masked-input
                                                autocomplete="off"
                                                type="text"
                                                v-model="fee.amount"
                                                placeholder="Enter Amount..."
                                                class="form-control text-right"
                                                :mask="currencyMask"
                                            >
                                            </masked-input>
                                        </td>
                                        <td class="align-middle text-right">
                                            {{formatCurrency(getExactAmt(fee.amount * fee.quantity))}}
                                        </td>
                                        <td class="align-middle text-center">
                                            <span role="button" @click="removeFee(fee, index)"
                                                ><i class="bx bx-x text-danger font-size-18"></i
                                            ></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right bg-primary bg-soft text-white font-weight-bold" colspan="3">Grand Total:</td>
                                        <td class="text-right bg-primary bg-soft text-white font-weight-bold">{{formatCurrency(getTotals('total'))}}</td>
                                        <td class="bg-primary bg-soft"></td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>
                    <small class="text-danger" v-if="getTotals('total') == 0">*Make sure to have at least 1 fee with a total of greater than zero.</small>
                </div>
            </div>
        </template>
        <template v-if="pageNo == 3">
            <div class="row">
                <div class="col-md-6">
                    <p class="mb-2 font-size-16 font-weight-bold">Review Billing:</p>
                    <table class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <td class="py-2">Type</td>
                                <th class="text-right text-yellow py-2">{{clientOpt.toUpperCase()}}</th>
                            </tr>
                            <tr>
                                <td class="py-2">Client Name</td>
                                <th class="text-right text-yellow py-2">{{billing.clientName}}</th>
                            </tr>
                            <tr>
                                <td class="py-2">Client Address</td>
                                <th class="text-right text-yellow py-2">{{billing.clientAddress}}</th>
                            </tr>
                            <!-- <tr>
                                <td class="py-2">Reference #</td>
                                <th class="text-right text-yellow py-2">{{billing.reference}}</th>
                            </tr> -->
                            <tr>
                                <td class="py-2">Billing Date</td>
                                <th class="text-right text-yellow py-2">{{formatDate(billing.billingDate)}}</th>
                            </tr>
                            <tr>
                                <td class="py-2" >Due Date</td>
                                <th class="text-right text-yellow py-2">{{formatDate(billing.dueDate)}}</th>
                            </tr>
                            <tr>
                                <td class="py-2">Description</td>
                                <th class="text-right text-yellow py-2">{{billing.description}}</th>
                            </tr>
                            <tr>
                                <td class="v-align-middle py-2">DU Services</td>
                                <th class="text-right py-2">
                                    <p class="font-weight-bold mb-0 text-yellow">
                                        {{duService.name}}
                                    </p>
                                    <p class="font-weight-bold mb-0 ps-3">
                                        {{duService.serviceName}}
                                    </p>
                                </th>
                            </tr>
                            <tr>
                                <td class="py-2">Penalty Per Day</td>
                                <th class="text-right text-yellow py-2">{{billing.penaltyPerDay > 0 ? `${billing.penaltyPerDay}%` : 'N/A' }}</th>
                            </tr>
                            <tr>
                                <td class="py-2">Send Notification?</td>
                                <th class="text-right text-yellow py-2">{{billing.emailSms ? 'Yes' : 'No' }}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="col-md-6">
                    <p class="mb-2 font-size-16 font-weight-bold">Fees:</p>
                    <table class="table table-sm table-hover table-bordered">
                        <thead>
                            <tr>
                                <th>Fee</th>
                                <th style="width:70px;" class="text-center">Qty</th>
                                <th style="width:150px;" class="text-center">Amount</th>
                                <th style="width:150px;" class="text-center">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="!billing.billingDetails.length">
                                <td colspan="100%" class="text-center">No data found.</td>
                            </tr>
                            <tr v-for="(fee, index) in billing.billingDetails" :key="index">
                                <td>{{ fee.name }}</td>
                                <td class="text-center">{{fee.quantity}}</td>
                                <td class="text-right">
                                    {{formatCurrency(getExactAmt(fee.amount))}}
                                </td>
                                <td class="text-right">{{formatCurrency(getExactAmt(parseFloat(fee.quantity) * parseFloat(fee.amount)))}}</td>
                            </tr>
                            <tr>
                                <td class="text-right bg-primary bg-soft text-white font-weight-bold" colspan="3">Grand Total:</td>
                                <td class="text-right bg-primary bg-soft text-white font-weight-bold">{{formatCurrency(getTotals('total'))}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
        <div class="modal-footer mt-4">
            <button type="submit" class="btn btn-primary d-flex align-items-center" v-if="pageNo != 1" @click="pageNo--">
                <i class="bx bx-left-arrow-alt font-size-18 me-1"></i> Previous 
            </button>
            <button type="submit" class="btn btn-primary d-flex align-items-center" v-if="nextMove(pageNo)" @click="nextNow">
                Next <i class="bx bx-right-arrow-alt font-size-18 ms-1"></i>
            </button>
            <button type="submit" class="btn btn-success d-flex align-items-center" v-if="pageNo == 3" @click="createBill">
                <i class="bx bx-save me-1"></i> {{billing.id == 0 ? 'Create' : 'Update'}} Bill
            </button>
        </div>
    </b-modal>
</template>
<style lang="scss">
.option-pane{
    border: 2px solid var(--bs-light);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    border-radius: 5px;
    height: 100px;
    font-size: 24px;
    width: 100%;
    cursor: pointer;
    .img-pane{
        width: 80px;
        margin-right: 20px;
    }
    p{
        border-left: 2px solid var(--bs-light);
        width: calc(100% - 80px);
        text-align: center;
    }
    &:hover{
        border-color: var(--bs-info);
        color: var(--bs-info);
    }
    &.active{
        border-color: var(--bs-info);
        color: var(--bs-info);
    }
}
.gap-2{
    gap: 2rem;
}
.template-opts{
    border: 1px solid var(--bs-gray-300);
    padding: 10px;
    text-align: center;
    border-radius: 25px;
    &.active{
        color: #fff;
        background: var(--bs-primary);
    }
}
</style>